/**
 * 草稿列表
 */

import React from 'react';
import { Ticon } from 'tplus-components-mobile';
import { Icon } from 'antd-mobile';
import { tools } from 'tplus-voucher';
import './index.less';
import NavPage from '../../routers/nav/NavPage';

@NavPage
export default class DraftList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      list: [],
      codeList: {
        'SA03': '销售订单',
        'SA0301':'退货申请',
        'SA04': '销货单',
        'SA0401':'退货单'
      },
      routerList: {
        'SA03': '/SO/SA03',
        'SA0301': '/SO/SA03',
        'SA04': '/SO/SA04',
        'SA0401': '/SO/SA04',
      }
    }
  }

  componentWillMount() {
    this.setState({
      list: (tools.getLocalCache('draftList') || []).sort((a, b) => b.date - a.date)
    })
  }


  navTitle() {
    return '草稿列表';
  }

  onClick = (item) => {
    this.push(`${this.state.routerList[item.code]}/${item.draftListID}`, {
      operateAction: 'draft',
      IsRejected :item.code == 'SA0401' || item.code == 'SA0301' ? true : false
    })
  }

  render() {
    let { list, codeList } = this.state;
    return (
      <div className='draftList'>
        {
          list && list.length > 0 ?
            list.map((item, i) => (
                <div className='row' key={i} onClick={this.onClick.bind(this, item)}>
                  <div className='row-name row-item'>{item.value.Customer.Name}</div>
                  <div className='row-type row-item'>{codeList[item.code]}</div>
                  <div className='row-date row-item'>{tools.dateFormat(item.date,'yyyy-MM-dd HH:mm')}</div>
                  <div className='row-money row-item'>{item.value.OrigTaxAmount && tools.comdify(parseFloat(item.value.OrigTaxAmount).toFixed(2))  || '0.00'}</div>
                </div>
              ))
            :
            <div className='nodata'>
              <div className='nodata-img'>
                <div className='nodata-icon'><Ticon type='meiyoufangan' className='meiyoufangan' /></div>
                <div className='nodata-text'>没有草稿</div>
              </div>
            </div>
        }
      </div>
    )
  }

}